import { render, staticRenderFns } from "./panel1.vue?vue&type=template&id=58f1c1ee&scoped=true&"
import script from "./panel1.vue?vue&type=script&lang=js&"
export * from "./panel1.vue?vue&type=script&lang=js&"
import style0 from "./panel1.vue?vue&type=style&index=0&id=58f1c1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1c1ee",
  null
  
)

export default component.exports